module.exports = __webpack_public_path__ + "media/common/icons/logo-full-f7fe926b7af80503f0b3c6ae13b8b9e9.svg";